import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannagePrevessin: React.FC = () => (
  <LocalSeoPage
    city="Prévessin-Moëns"
    cityShort="Prévessin"
    slug="depannage-informatique-prevessin-moens"
    metaTitle="Dépannage Informatique Prévessin-Moëns | SOS IT Services"
    metaDescription="Technicien informatique à Prévessin-Moëns. PC lent, virus, WiFi, Windows. Intervention rapide à domicile ou à distance. Diagnostic gratuit."
    intro="Votre ordinateur vous cause des soucis à Prévessin-Moëns ? Notre technicien intervient rapidement à domicile ou à distance. PC lent, virus, problème WiFi ou Windows bloqué — on trouve la solution. Diagnostic gratuit, devis clair, zéro surprise."
    postalCode="01280"
    nearbyTowns={[
      { name: 'Saint-Genis-Pouilly', link: '/depannage-informatique-saint-genis-pouilly' },
      { name: 'Ferney-Voltaire', link: '/depannage-informatique-ferney-voltaire' },
      { name: 'Gex', link: '/depannage-informatique-gex' },
      { name: 'Divonne-les-Bains', link: '/depannage-informatique-divonne-les-bains' },
      { name: 'Saint-Julien-en-Genevois', link: '/depannage-informatique-saint-julien-en-genevois' },
      { name: 'Thoiry' },
      { name: 'Cessy' },
    ]}
    internalLinks={[
      { label: 'Dépannage informatique à Saint-Genis-Pouilly', href: '/depannage-informatique-saint-genis-pouilly' },
      { label: 'Dépannage informatique à Ferney-Voltaire', href: '/depannage-informatique-ferney-voltaire' },
      { label: 'Dépannage informatique à Gex', href: '/depannage-informatique-gex' },
      { label: 'Dépannage informatique à Divonne-les-Bains', href: '/depannage-informatique-divonne-les-bains' },
      { label: 'Dépannage informatique à Saint-Julien-en-Genevois', href: '/depannage-informatique-saint-julien-en-genevois' },
      { label: 'Dépannage informatique dans le Genevois', href: '/depannage-informatique-genevois' },
    ]}
  />
);

export default DepannagePrevessin;
